/**
 * @description 判断是否为 null
 */
export const isNull = (value: any): boolean => {
  return value === null;
};
